// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__M1X2u","name":"ConsentHeader_name__1FUCm","birthday":"ConsentHeader_birthday__1xOwr","skeleton":"ConsentHeader_skeleton__QFffb"};